module.exports = __webpack_public_path__ + "img/forgot-mail.5baf606d.svg";